import { InvoiceListRowsSkeleton } from "../loading/SkeletonBlocks.jsx";
import {
  formatSignedMoneyCents,
  humanizeBalanceTransactionType,
} from "../../lib/money.js";
import { formatBillingInstant } from "../../lib/stripeInstant.js";

export default function ConnectRecentActivityList({
  activity,
  currency = "cad",
  isLoading,
  className = "",
}) {
  const rows = activity ?? [];

  return (
    <section
      className={`overflow-hidden rounded-2xl border border-hc-surface-border bg-hc-surface ${className}`}
    >
      <div className="border-b border-hc-surface-border px-5 py-3.5">
        <h2 className="text-sm font-semibold tracking-[-0.15px] text-hc-text">
          Recent activity
        </h2>
        <p className="mt-0.5 text-xs text-hc-text-dim">
          Charges, payouts, and refunds on your payout account.
        </p>
      </div>

      {isLoading ? (
        <InvoiceListRowsSkeleton rows={3} />
      ) : rows.length === 0 ? (
        <p className="px-5 py-6 text-xs text-hc-text-dim">No recent activity yet.</p>
      ) : (
        <ul className="divide-y divide-hc-surface-border/80">
          {rows.map((row) => (
            <li
              key={row.id}
              className="flex flex-wrap items-center justify-between gap-3 px-5 py-4"
            >
              <div>
                <p className="text-sm tracking-[-0.15px] text-hc-text">
                  {humanizeBalanceTransactionType(row.type)}
                </p>
                <p className="text-xs text-hc-text-dim">
                  {row.description || formatBillingInstant(row.created) || "—"}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold tracking-[-0.15px] text-hc-text">
                  {formatSignedMoneyCents(row.netCents, row.currency ?? currency)}
                </p>
                <p className="text-xs text-hc-text-dim">
                  {formatBillingInstant(row.created) || "—"}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
